<script>
import {useEvaluationPhaseStore} from "@/stores/Evaluation/EvaluationPhase";
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData";
import axios from "axios";

export default {
    props: {
        value: [Number, Array],
        multiple: Boolean,
        label: String,
        readonly: Boolean,
        notClearable: Boolean,
        useLocalCache: Boolean,
        rules: Array,
        type: String,
    },
    setup(props) {
        const evaluationPhaseStore = useEvaluationPhaseStore();
        const {loading, inputColor, backgroundColor} = useSharedData();
        const evaluationPhase = ref(null);
        const evaluationPhases = ref([]);

        function findAll() {
            loading.value = true;
            axios.get('/evaluationPhases', {
                params: {
                    type: props.type,
                }
            }).then(response => {
                if (props.useLocalCache) {
                    evaluationPhases.value = response.data;
                } else {
                    evaluationPhaseStore.setEvaluationPhases(response.data);
                }
            }).finally(() => {
                loading.value = false;
            })
        }

        watch(() => props.value, () => {
            if (props.value)
                evaluationPhase.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            evaluationPhaseStore,
            evaluationPhase,
            evaluationPhases,
            loading,
            inputColor,
            backgroundColor
        }
    }
};
</script>

<template>
    <div>
        <v-autocomplete
            v-model="evaluationPhase"
            :label="label"
            :items="useLocalCache ? evaluationPhases : evaluationPhaseStore.evaluationPhases"
            item-value="id"
            item-text="name"
            outlined
            dense
            :loading="loading"
            :readonly="readonly"
            :multiple="multiple"
            :chips="multiple"
            :deletable-chips="multiple"
            :clearable="!(readonly || notClearable)"
            :color="inputColor"
            :background-color="backgroundColor"
            hide-details="auto"
            @input="$emit('input', evaluationPhase)"
            :rules="rules"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>